
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8bI7u", function(module, exports) {

$parcel$export(module.exports, "PendoAnalytics", () => $929eebe0cae53103$export$5b517672761df363);

var $5uXOq = parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $10Nlw = parcelRequire("10Nlw");

var $902O6 = parcelRequire("902O6");

var $fG5AJ = parcelRequire("fG5AJ");

var $10xFf = parcelRequire("10xFf");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $bw7Gm = parcelRequire("bw7Gm");

var $dAfqg = parcelRequire("dAfqg");

var $2tT7R = parcelRequire("2tT7R");

var $9OXo1 = parcelRequire("9OXo1");

var $eJqJI = parcelRequire("eJqJI");

parcelRequire("ceLuh");
let $929eebe0cae53103$var$pendingRequestJira = Promise.resolve();
function $929eebe0cae53103$var$reportError(error, id, message) {
    // As the operation like initialize/update/teardown are asynchronous, there's a chance that window.pendo
    // could be deleted while switching contexts between JPD and Jira hence the window.pendo might not be available and we would report these issues
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraCommonPendoAnalytics'
        },
        attributes: {
            message: message
        },
        error: error
    });
}
const $929eebe0cae53103$var$initializePendoWithChecking = async (apiKey, appName, pendoConfig, environment)=>{
    const id = `pendo-agent-${apiKey}`;
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.pendo && window.pendo.teardown && apiKey !== window.pendo.apiKey) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.pendo.teardown();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window.pendo;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $929eebe0cae53103$var$reportError(error, 'jiraPendoAnalyticsTeardown', 'Failed to teardown pendo');
    }
    await (0, $902O6.checkThirdParty)('pendo-main', async ()=>{
        const config = (0, $4R6GH.fg)('post-office_enable_pendo_choreographer') ? (0, $fG5AJ.getPendoPlugin)((0, $10xFf.environmentToEnvType)(environment)).getPendoConfig(pendoConfig) : pendoConfig;
        if (!(0, $co1wz.ff)('pendo-jira-load-only-for-eng-users_q9w6l') || pendoConfig?.visitor?.language_preference.startsWith('en')) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            let script = document.getElementById(id);
            if (script) {
                // @ts-expect-error as id is not in the global window
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.pendo = window[id];
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    if (window?.globalPendoAppName === appName) {
                        const updateInterval = setInterval(()=>{
                            if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            window.pendo !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            typeof window.pendo.initialize === 'function' && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            typeof window.pendo.updateOptions === 'function') {
                                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                if (apiKey !== window?.pendo?.apiKey) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                window.pendo.initialize(config);
                                else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                window.pendo.updateOptions(config);
                                clearInterval(updateInterval);
                            }
                        }, 1000);
                    }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $929eebe0cae53103$var$reportError(error, 'jiraPendoAnalyticsInitializeUpdate', 'Failed to initialize/update pendo');
                }
            } else {
                // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
                script = document.createElement('script');
                script.id = id;
                if (script instanceof HTMLScriptElement) script.defer = true;
                script.onload = ()=>{
                    // @ts-expect-error as id is not in the global window
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window[id] = window.pendo;
                    try {
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        if (window?.globalPendoAppName === appName) {
                            const initializeInterval = setInterval(()=>{
                                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                if (window.pendo !== undefined && typeof window.pendo.initialize === 'function') {
                                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                    window.pendo.initialize(config);
                                    clearInterval(initializeInterval);
                                }
                            }, 1000);
                        }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        $929eebe0cae53103$var$reportError(error, 'jiraPendoAnalyticsInitialize', 'Failed to initialize pendo');
                    }
                };
                if (script instanceof HTMLScriptElement) script.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.head.appendChild(script);
            }
        }
    });
};
const $929eebe0cae53103$var$addPendoWidget = (props)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, cloudName: cloudName, appEditions: appEditions, apiKey: apiKey, editionKey: editionKey, appName: appName, language: language, displayMode: displayMode, environment: environment } = props;
    // Added Location Config
    const pendoConfig = {
        visitor: {
            id: atlassianAccountId,
            language_preference: language,
            display_mode: displayMode
        },
        account: {
            id: `${appName}-${cloudId}`,
            workspace_name: cloudName,
            edition: editionKey === 'common' ? 'na' : appEditions?.[editionKey]
        },
        location: {
            transforms: [
                {
                    attr: 'href',
                    action: 'Replace',
                    data: (href)=>`${(0, $bw7Gm.default)(href)}`
                },
                {
                    attr: 'pathname',
                    action: 'Replace',
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    data: (pathname)=>`${pathname}/${window?.globalPendoAppName}`
                }
            ]
        },
        disableGuidePseudoStyles: true,
        // Building block guides use an inline style tag for various pseudo styles (e.g. hover, carets, animations).
        // These can be turned off using this flag for application's with more restrictive CSP settings but will require custom effort to reach style parity.
        guides: {
            // If true, custom code blocks in building block guides will not be allowed to run. Also, classic guides will not be shown at all.
            preventCodeInjection: true,
            globalScripts: (0, $4R6GH.fg)('pendo-gsac-changes-globalscrips') ? $929eebe0cae53103$export$7be014228b4d4c4a : []
        }
    };
    $929eebe0cae53103$var$pendingRequestJira = $929eebe0cae53103$var$pendingRequestJira.then(()=>$929eebe0cae53103$var$initializePendoWithChecking(apiKey, appName, pendoConfig, environment));
};
const $929eebe0cae53103$export$7be014228b4d4c4a = [
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        script (_step, _guide) {
            const acceptedJavaScript = {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                'window.location.href': window.location.href,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                'window.location.pathname': window.location.pathname
            };
            const result = processFillPolls(acceptedJavaScript);
            function getValueFromFillPoll(fillPollText) {
                const fillPollValue = fillPollText.split('{fillPoll: "')[1].split('"/}')[0];
                return fillPollValue;
            }
            function processFillPolls(acceptedJavaScriptObject) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const fillPollElements = window.pendo.dom('._pendo-open-text-poll-question p[id*="pendo-text"]:contains("{fillPoll")');
                if (fillPollElements.length > 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fillPollElements.each((el)=>{
                    const javascriptRule = getValueFromFillPoll(el.innerText);
                    const pollId = el.parentElement.parentElement.dataset.pendoPollId;
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const textarea = document.querySelector(`textarea[data-pendo-poll-id="${pollId}"]`);
                    if (textarea) {
                        if (textarea instanceof HTMLTextAreaElement) // Now you can safely use textarea as an HTMLTextAreaElement
                        textarea.value = `URL=${acceptedJavaScriptObject[javascriptRule]}`;
                    }
                });
                return fillPollElements;
            }
            return result;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        test (step, _guide) {
            return step;
        }
    },
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        script (_step, _guide) {
            const result = processHiddenRows();
            function processHiddenRows() {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const hiddenRows = window.pendo.dom('div[id*="pendo-text"]:contains("{hidden/}")');
                if (hiddenRows) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                hiddenRows.each((el)=>{
                    const elUpdated = el;
                    elUpdated.style.visibility = 'hidden';
                    elUpdated.style.display = 'none';
                    if (elUpdated.dataset.pendoPollId) {
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        const linkedPollElements = window.pendo.dom(`[data-pendo-poll-id="${elUpdated.dataset.pendoPollId}"]`);
                        if (linkedPollElements) linkedPollElements.each((linkedPollEl)=>{
                            const updatedLinkedPollEl = linkedPollEl;
                            if (updatedLinkedPollEl.nodeName === 'FORM') {
                                updatedLinkedPollEl.parentNode.parentNode.style.visibility = 'hidden';
                                updatedLinkedPollEl.parentNode.parentNode.style.display = 'none';
                            } else {
                                updatedLinkedPollEl.style.visibility = 'hidden';
                                updatedLinkedPollEl.style.display = 'none';
                            }
                        });
                    }
                });
                return hiddenRows;
            }
            return result;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        test (step, _guide) {
            return step;
        }
    },
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        script (_step, _guide) {
            const result = processDeepLinkButton();
            function processDeepLinkButton() {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const button = window.pendo?.dom('button[id*="pendo-button"]');
                if (button.length > 0 && button[0].innerHTML.includes('{{billing-preview-pendo}}')) {
                    button[0].innerHTML = button[0].innerHTML.replace('{{billing-preview-pendo}}', '');
                    button.on('click', ()=>{
                        const CLOUD_ADMIN_URL = `https://${(0, $10Nlw.getATLContextDomain)('admin')}`;
                        let newurl = CLOUD_ADMIN_URL; // default if newurl build fails
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        const accountid = window.pendo?.getSerializedMetadata().account.id;
                        const dashindex = accountid.indexOf('-');
                        const cloudId = accountid.substring(dashindex + 1); // strip out "jsw-" from account.id to get cloudId
                        if (cloudId.length > 10) newurl = `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        window.pendo?.onGuideDismissed();
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        window.open(newurl, '_blank');
                    });
                }
                return button;
            }
            return result;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        test (step, _guide) {
            return step;
        }
    }
];
const $929eebe0cae53103$export$5b517672761df363 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    const loadingRef = (0, $5uXOq.useRef)(false);
    const { loading: loading, error: error, data: data } = (0, $dAfqg.useProjectContext)();
    const environment = (0, $2tT7R.useEnvironment)();
    (0, $5uXOq.useEffect)(()=>{
        // If the project context is loading, we don't want to render the Pendo widget
        // we only want to show pendo when we are inside a project
        if (loading) return;
        // If the project context is loaded, let's make sure that there was no
        // errors and the data exists.
        const projectContextLoaded = !loading && !error && data;
        const isProjectLoaded = loadingRef.current || projectContextLoaded;
        loadingRef.current = loading;
        // Pendo Snippet is only for JWM JSM JSW products and NOT for JPD as they have separate implementation
        if (isProjectLoaded && data?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return;
        // as checked above, there should always be projectType, but we'll provide a
        // sensible default just in case
        const jiraAppName = data?.projectType || (0, $8e76b4dd832736a3$export$b40f9fec24e148b0);
        const { apiKey: apiKey, appName: appName, editionKey: editionKey } = (0, $eJqJI.APP_KEY_NAME_MAPPING)[jiraAppName];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.globalPendoAppName = appName;
        // by this point, we know that we are in a project and we have the correct
        // data to render the pendo widget
        const pendoProps = {
            atlassianAccountId: tenantContext.atlassianAccountId,
            cloudId: tenantContext.cloudId,
            cloudName: tenantContext.cloudName,
            appEditions: tenantContext?.appEditions,
            // By default, the colorThemeObserver will return undefined - that means it is light
            displayMode: colorMode || 'light',
            language: tenantContext.locale,
            appName: appName,
            apiKey: // Fix: Cast appName to AppName type
            apiKey,
            editionKey: editionKey,
            environment: // Assign a default value of type EditionKey
            environment
        };
        $929eebe0cae53103$var$addPendoWidget(pendoProps);
        return ()=>{
            // In non-project area guides should not be displayed. setting it empty means location API will not display any guides.
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.globalPendoAppName = '';
        };
    }, [
        loading,
        error,
        data,
        tenantContext,
        tenantContext.atlassianAccountId,
        tenantContext.cloudId,
        tenantContext.cloudName,
        tenantContext.locale,
        colorMode,
        loadingRef,
        environment
    ]);
    return null;
};

});
parcelRegister("902O6", function(module, exports) {

$parcel$export(module.exports, "checkThirdParty", () => $ea550cf043223388$export$6112f3b5ec1bcd0);

var $6Rvo6 = parcelRequire("6Rvo6");
const $ea550cf043223388$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
    await (0, $6Rvo6.checkThirdParty)(thirdParty, onAllowed, onDenied);
};

});
parcelRegister("6Rvo6", function(module, exports) {

$parcel$export(module.exports, "checkThirdParty", () => $7c246f7f8304e777$export$6112f3b5ec1bcd0);

var $eSKig = parcelRequire("eSKig");

var $8cjcX = parcelRequire("8cjcX");

var $cDLZF = parcelRequire("cDLZF");
const $7c246f7f8304e777$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
    try {
        const isAllowed = await (0, $cDLZF.isThirdPartyAllowed)(thirdParty);
        (0, $eSKig.sendPackageOperationalEvent)({
            action: 'usedCheckThirdParty',
            attributes: {
                wasRejected: !isAllowed,
                thirdParty: thirdParty
            }
        });
        return isAllowed ? onAllowed() : onDenied?.();
    } catch (e) {
        (0, $8cjcX.Logger).errorWithOperationalEvent({
            action: 'checkThirdPartyError',
            attributes: {
                wasRejected: true,
                thirdParty: thirdParty
            },
            message: `Failed to use check third party. ${e.message || ''}`
        });
    }
};

});
parcelRegister("cDLZF", function(module, exports) {

$parcel$export(module.exports, "isThirdPartyAllowed", () => $c5dacc478666473b$export$3df7084d4be668cd);

var $imvW4 = parcelRequire("imvW4");

var $6LRsT = parcelRequire("6LRsT");

var $331oV = parcelRequire("331oV");
const $c5dacc478666473b$export$3df7084d4be668cd = async (thirdParty)=>{
    /*
    If no preferences for whatever reason, deny
    If prefs exist and are default, they will default to block all
    If third party has no category for whatever reason or the data doesn't resolve, deny
    If third party has a category, check preferences and allow/deny
  */ const preferences = await (0, $331oV.getPreferences)();
    if (!preferences) return Promise.resolve(false);
    let shouldDenyThirdParty = false;
    let storageControlsData;
    const { loadCache: loadCache } = (0, $imvW4.getBscGlobalState)();
    storageControlsData = await loadCache((0, $6LRsT.CategoryStorageType).Cookies);
    if (storageControlsData) {
        const { thirdPartyKeys: thirdPartyKeys, categories: categories } = storageControlsData;
        const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
        const numToCategoryMap = {
            [categories.STRICTLY_NECESSARY]: (0, $6LRsT.PreferenceCategory).StrictlyNecessary,
            [categories.FUNCTIONAL]: (0, $6LRsT.PreferenceCategory).Functional,
            [categories.ANALYTICS]: (0, $6LRsT.PreferenceCategory).Analytics,
            [categories.MARKETING]: (0, $6LRsT.PreferenceCategory).Marketing,
            [categories.UNKNOWN]: (0, $6LRsT.PreferenceCategory).Unknown
        };
        const thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
        let hasPreferencesForCategoryType = false;
        if (!!thirdPartyCategory) hasPreferencesForCategoryType = preferences[thirdPartyCategory];
        shouldDenyThirdParty = hasPreferencesForCategoryType;
    }
    return Promise.resolve(shouldDenyThirdParty);
};

});



parcelRegister("eJqJI", function(module, exports) {

$parcel$export(module.exports, "APP_KEY_NAME_MAPPING", () => $1dbeaa4a630423c8$export$e1484ba0e8570538);
const $1dbeaa4a630423c8$var$API_KEY_JIRA = '0678af2a-df89-42a3-4abb-60978aa54814';
const $1dbeaa4a630423c8$export$e1484ba0e8570538 = {
    business: {
        apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
        appName: 'jwm',
        editionKey: 'core'
    },
    software: {
        apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
        appName: 'jsw',
        editionKey: 'software'
    },
    service_desk: {
        apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
        appName: 'jsm',
        editionKey: 'serviceDesk'
    },
    customer_service: {
        apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
        appName: 'jcs',
        editionKey: 'customerService'
    },
    common: {
        apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
        appName: 'common',
        editionKey: 'common'
    },
    product_discovery: {
        apiKey: '',
        appName: 'jpd',
        editionKey: 'productDiscovery'
    }
};

});

const $8e76b4dd832736a3$export$b40f9fec24e148b0 = 'common';

parcelRegister("ceLuh", function(module, exports) {
const $8e8ba0d493460b33$var$style = document.createElement('style');
$8e8ba0d493460b33$var$style.textContent = `#pendo-guide-container ._pendo-backdrop{background:var(--ds-blanket,#091e427f)!important}#pendo-guide-container{background-color:var(--ds-surface-overlay,#fff)!important;box-shadow:var(--ds-shadow-overlay,0px 0px 8px #091e4229,0px 0px 1px #091e421f)!important;border:var(--ds-border,#091e4224)!important;border-radius:var(--ds-border-radius,3px)!important}#pendo-guide-container [id^=pendo-guide-data-text]{color:var(--ds-text,#172b4d)!important}#pendo-guide-container .pendo-tooltip-caret--top,#pendo-guide-container .pendo-tooltip-caret--top+.pendo-tooltip-caret-border{border-top-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--right,#pendo-guide-container .pendo-tooltip-caret--right+.pendo-tooltip-caret-border{border-right-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--bottom{border-bottom-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--left{border-left-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--top+.pendo-tooltip-caret-border{border-top-color:var(--ds-border,#091e4224)!important}#pendo-guide-container .pendo-tooltip-caret--right+.pendo-tooltip-caret-border{border-right-color:var(--ds-border,#091e4224)!important}#pendo-guide-container .pendo-tooltip-caret--bottom+.pendo-tooltip-caret-border{border-bottom-color:var(--ds-border,#091e4224)!important}#pendo-guide-container .pendo-tooltip-caret--left+.pendo-tooltip-caret-border{border-left-color:var(--ds-border,#091e4224)!important}#pendo-guide-container ._pendo-text-paragraph,#pendo-guide-container ._pendo-text-custom,#pendo-guide-container ._pendo-text-subTitle,#pendo-guide-container ._pendo-text-title,#pendo-guide-container ._pendo-nps-open-text-poll-question{color:var(--ds-text,#172b4d)!important}#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link,#pendo-guide-container ._pendo-text-custom ._pendo-text-link,#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link,#pendo-guide-container ._pendo-text-title ._pendo-text-link{color:var(--ds-link,#0052cc)!important;text-decoration:underline!important}#pendo-guide-container ._pendo-button,#pendo-guide-container ._pendo-dummy-primary-button{border-radius:var(--ds-border-radius,3px)!important;font-weight:var(--ds-font-weight-medium,500)!important}#pendo-guide-container ._pendo-button-primaryButton{background-color:var(--ds-background-brand-bold,#0c66e4)!important;color:var(--ds-text-inverse,#fff)!important}#pendo-guide-container ._pendo-button-tertiaryButton,#pendo-guide-container ._pendo-button-custom{background-color:var(--ds-background-neutral-subtle,#0000)!important;color:var(--ds-text-subtle,#44546f)!important}#pendo-guide-container div[class*=_pendo-number-scale-poll]{color:var(--ds-text,#172b4d)!important}#pendo-guide-container ._pendo-multi-choice-poll-select-border{border-width:var(--ds-border-width-0,0px)!important;background-color:#0000!important}#pendo-guide-container ._pendo-multi-choice-poll-select{cursor:pointer;box-sizing:border-box;background-color:var(--ds-background-neutral,#091e420f)!important;color:var(--ds-text,#42526e)!important;border-radius:var(--ds-border-radius-100,3px)!important}#pendo-guide-container [id^=pendo-radio-select-] label.pendo-radio{color:var(--ds-text,#172b4d)!important;margin-top:2px!important}#pendo-guide-container ._pendo-open-text-poll-input{background-color:var(--ds-background-input,#fff)!important;border:1px solid var(--ds-border-input,#8590a2)!important;border-radius:var(--ds-border-radius,3px)!important;color:var(--ds-text,#091e42)!important}#pendo-guide-container [id^=pendo-radio-select] input[type=radio]{background-color:var(--radio-background-color);border:var(--ds-border-width,1px)solid var(--radio-border-color);border-radius:var(--ds-border-radius-circle,50%);--radio-background-color:var(--ds-background-input,#fff);--radio-border-color:var(--ds-border-input,#8590a2);outline:none;width:var(--ds-space-300,24px)!important;height:var(--ds-space-300,24px)!important;margin:var(--ds-space-0,0px)!important;--radio-dot-color:var(--ds-icon-inverse,#fff)!important;--radio-dot-opacity:0!important;vertical-align:top!important;appearance:none!important;flex-shrink:0!important;justify-content:center!important;align-items:center!important;transition:border-color .2s ease-in-out,background-color .2s ease-in-out!important;display:flex!important;position:relative!important;transform:scale(.583333)!important}#pendo-guide-container ._pendo-required-indicator{color:var(--ds-text-danger,#ae2e24)!important;font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;padding-inline-start:var(--ds-space-025,2px)!important}#pendo-guide-container :focus-visible::-moz-focus-inner:not(.pendo-start-focus-bumper:focus-visible:-moz-focus-inner .pendo-end-focus-bumper:focus-visible:-moz-focus-inner){border-radius:var(--ds-border-radius,3px)!important}#pendo-guide-container :focus-visible:not(.pendo-start-focus-bumper:focus-visible,.pendo-end-focus-bumper:focus-visible,.pendo-radio:focus-visible,._pendo-open-text-poll-input:focus-visible,._pendo-close-guide:focus-visible,._pendo-multi-choice-poll-select-border){outline:none!important;outline-color:var(--ds-border-focused,#388bff)!important;outline-width:var(--ds-border-width-outline,2px)!important;outline-offset:var(--ds-space-025,2px)!important;border-radius:var(--ds-border-radius,3px)!important;outline-style:solid!important}#pendo-guide-container ._pendo-close-guide:focus-visible{outline-offset:0px!important}#pendo-guide-container [id^=pendo-radio-select] input[type=radio]:checked{--radio-background-color:var(--ds-background-selected-bold,#0052cc)!important;--radio-border-color:var(--ds-background-selected-bold,#0052cc)!important;--radio-dot-opacity:1!important}#pendo-guide-container [id^=pendo-radio-select] input[type=radio]:after{background:var(--radio-dot-color);border-radius:var(--ds-border-radius-circle,50%);content:"";width:6.85714px;height:6.85714px;opacity:var(--radio-dot-opacity);transition:background-color .2s ease-in-out,opacity .2s ease-in-out;position:absolute}#pendo-guide-container .pendo-radio:focus-visible{outline:var(--ds-border-width-outline,3px)solid var(--ds-border-focused,#2684ff)!important;outline-offset:var(--ds-border-width-indicator,3px)!important}#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link:hover,#pendo-guide-container ._pendo-text-custom ._pendo-text-link:hover,#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link:hover,#pendo-guide-container ._pendo-text-title ._pendo-text-link:hover{color:var(--ds-link,#0052cc)!important;text-decoration:underline!important}#pendo-guide-container ._pendo-button-primaryButton:hover{background-color:var(--ds-background-brand-bold-hovered,#05c)!important}#pendo-guide-container ._pendo-button-secondaryButton:hover,#pendo-guide-container ._pendo-button-tertiaryButton:hover,#pendo-guide-container ._pendo-button-custom:hover{color:var(--ds-text-subtle,#44546f)!important;background-color:var(--ds-background-neutral-hovered,#091e4224)!important}#pendo-guide-container ._pendo-button:disabled._pendo-button[disabled]{border-radius:var(--ds-border-radius-100,3px)!important;border-color:currentColor!important;border-width:var(--ds-border-width-0,0px)!important;text-align:center!important;background-color:var(--ds-background-disabled,#091e4208)!important;color:var(--ds-text-disabled,#091e424f)!important;cursor:not-allowed!important;pointer-events:auto!important;padding-inline-start:var(--ds-space-150,12px)!important;padding-inline-end:var(--ds-space-150,12px)!important;text-decoration:none!important;transition:background .1s ease-out,box-shadow .15s cubic-bezier(.47,.03,.49,1.38)!important}#pendo-guide-container ._pendo-open-text-poll-input::placeholder{color:var(--ds-text-subtlest,#6b778c)!important}#pendo-guide-container ._pendo-close-guide{top:var(--ds-space-250,20px)!important;right:var(--ds-space-250,20px)!important;color:var(--ds-icon,#172b4d)!important;border-radius:var(--ds-border-radius,3px)!important;cursor:pointer!important;justify-content:center!important;align-items:center!important;width:32px!important;height:32px!important;padding-bottom:5px!important;font-size:30px!important;font-weight:300!important;transition:background .1s ease-out!important;display:flex!important}#pendo-guide-container ._pendo-close-guide:hover{background-color:var(--ds-background-neutral-subtle-hovered,#091e420f)!important;color:var(--ds-icon,#172b4d)!important}#pendo-guide-container ._pendo-close-guide:active{background-color:var(--ds-background-neutral-subtle-pressed,#091e4224)!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio{background-color:var(--ds-background-input,#fff)!important;border-width:var(--ds-border-width,1px)!important;border-style:solid!important;border-color:var(--ds-border-input,#8590a2)!important;color:var(--ds-text,#172b4d)!important;justify-content:center!important;align-items:center!important;display:flex!important}#pendo-guide-container label[class*=_pendo-number-scale-poll]{margin-left:0!important;margin-right:4px!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio:hover{background-color:var(--ds-background-input-hovered,#f7f8f9)!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio:active{background-color:var(--ds-background-input-pressed,#fff)!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper input[type=radio].pendo-radio:checked+label{background-color:var(--ds-background-selected,#cce0ff)!important;color:var(--ds-text-selected,#0c66e4)!important;border-color:var(--ds-border-selected,#0c66e4)!important;border-width:2px!important}#pendo-guide-container ._pendo-button-primaryButton._pendo-button:hover{background:var(--ds-background-brand-bold-hovered,#05c)!important}#pendo-guide-container ._pendo-button-primaryButton._pendo-button:active{background:var(--ds-background-brand-bold-pressed,#09326c)!important}#pendo-guide-container ._pendo-button-secondaryButton._pendo-button:hover,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-yes-button:hover,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button:hover{background:var(--ds-background-neutral-hovered,#091e4224)!important}#pendo-guide-container ._pendo-button-secondaryButton._pendo-button:active ._pendo-button._pendo-yes-no-poll-yes-button:active,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button:active{background:var(--ds-background-neutral-pressed,#091e424f)!important}#pendo-guide-container ._pendo-button-tertiaryButton._pendo-button:hover{background:var(--ds-background-neutral-subtle-hovered,#091e420f)!important}#pendo-guide-container ._pendo-button-tertiaryButton._pendo-button:active{background:var(--ds-background-neutral-subtle-pressed,#091e4224)!important}#pendo-guide-container h2{font:var(--ds-font-heading-medium,normal 500 20px/24px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;margin-bottom:var(--ds-space-100,8px)!important}#pendo-guide-container h3{font:var(--ds-font-heading-small,normal 600 16px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;margin-top:4px!important;margin-bottom:var(--ds-space-100,8px)!important}#pendo-guide-container ._pendo-text-paragraph._pendo-open-text-poll-question,#pendo-guide-container ._pendo-text-paragraph._pendo-multi-choice-poll-question{padding-top:var(--ds-space-100,4px)!important;margin-bottom:var(--ds-space-050,4px)!important;color:var(--ds-text-subtle,#44546f)!important;font:400 12px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,Segoe UI,Ubuntu,system-ui,Helvetica Neue,sans-serif!important;font-weight:var(--ds-font-weight-semibold,600)!important}#pendo-guide-container ._pendo-text-paragraph{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important}#pendo-guide-container ._pendo-number-scale-poll-1-description,#pendo-guide-container ._pendo-number-scale-poll-5-description{margin-top:var(--ds-space-050,4px)!important;color:var(--ds-text-subtle,#44546f)!important}#pendo-guide-container label.pendo-radio:hover,#pendo-guide-container input[type=radio].pendo-radio:checked+label{background-color:#0000!important}#pendo-guide-container ._pendo-multi-choice-poll-select-border input[type=radio].pendo-radio:focus+label{outline:none!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper input[type=radio].pendo-radio:focus+label{outline-offset:4px!important;outline-color:var(--ds-border-focused,#388bff)!important}#pendo-guide-container{padding:var(--ds-space-300,24px)!important}#pendo-guide-container ._pendo-open-text-poll-input{transition:background-color .2s ease-in-out,border-color .2s ease-in-out;font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;margin-block:0!important}#pendo-guide-container ._pendo-open-text-poll-input:focus-visible{box-shadow:inset 0 0 0 var(--ds-border-width,1px)var(--ds-border-focused,#2684ff)!important;border-color:var(--ds-border-focused,#2684ff)!important;outline:none!important}#pendo-guide-container ._pendo-open-text-poll-input:hover{background-color:var(--ds-background-input-hovered,#f7f8f9)!important}#pendo-guide-container ._pendo-multi-choice-poll-select{background:var(--ds-background-input,#fff)!important;border-width:var(--ds-border-width,1px)!important;border:solid var(--ds-border-input,#8590a2)!important;padding-inline:var(--ds-space-075,6px)!important;padding-block:var(--ds-space-025,2px)!important;transition:background-color .2s ease-in-out,border-color .2s ease-in-out!important}#pendo-guide-container ._pendo-multi-choice-poll-select:hover{background-color:var(--ds-background-input-hovered,#f7f8f9)!important}#pendo-guide-container ._pendo-multi-choice-poll-select:active{background-color:var(--ds-background-input-pressed,#fff)!important}#pendo-guide-container hr{border-color:var(--ds-border,#091e4224)!important;margin-block:var(--ds-space-100,8px)!important;border-width:var(--ds-border-width,1px)0 0!important}#pendo-guide-container ._pendo-button{height:var(--ds-space-400,32px)!important;font-weight:var(--ds-font-weight-medium)!important;padding-inline:var(--ds-space-150,12px)!important;cursor:pointer!important;padding-block:0!important;transition:background .1s ease-out!important}#pendo-guide-container ._pendo_button:hover,#pendo-guide-container ._pendo_button:active{transition-duration:0s!important}#pendo-guide-container ._pendo-button-secondaryButton,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-yes-button,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button{background-color:var(--ds-background-neutral,#091e420f)!important;color:var(--ds-text,#172b4d)!important}#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link:active,#pendo-guide-container ._pendo-text-custom ._pendo-text-link:active,#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link:active,#pendo-guide-container ._pendo-text-title ._pendo-text-link:active{color:var(--ds-link-pressed,#05c)!important}`;
document.querySelector('head').appendChild($8e8ba0d493460b33$var$style);

});



//# sourceMappingURL=async-pendo-analytics.2f284372.js.map
